import React from "react";

function ComplaintApprovedIcon() {
  return (
    <svg width="87" height="87" viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="43.2347" cy="43.2347" r="43.2347" fill="#39B260" fillOpacity="0.19" />
      <circle cx="43.2335" cy="43.2355" r="30.8819" fill="#39B260" fillOpacity="0.17" />
      <path d="M36.5 43.7L41.2 48.4L50.5 39.1" stroke="#39B260" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default ComplaintApprovedIcon;
